import React, { useRef, useEffect, useCallback, useState} from 'react';
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import {useSticky} from './useSticky.js';
import {connect} from 'react-redux';

const SidePanelToolbar = (props) => { 
    const ref = useRef(undefined);
    const {sticky} = useSticky({
        scrollContainer: props.scrollContainer,
        stickyContainer: ref
    });
    let style = sticky ? sticky : {};
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const onNewMix = () => {
        props.sequencerEngine.mix.clear();
        props.sequencerEngine.subSequences.forEach(
            s => s.mix.clear());
        // find all mix automations and delete them
        for (let s of props.sequencerEngine.subSequences) {
            for (let track of s.tracks) {
                let automatedParameters = track.getAllParameters()
                    .filter(
                        x => x.mixAutomation &&
                            x.mixAutomation.automations.length > 0);
                automatedParameters.forEach(
                    s => s.mixAutomation.deleteAutomations());
            }
        }
    };

    return (
        <div style={style} ref={ref} className="side-panel-toolbar">
          <ButtonDropdown
            className="view-dropdown"
            show={dropdownOpen ? "true" : "false"}
            isOpen={dropdownOpen}
            toggle={() => setDropdownOpen(!dropdownOpen)}>
            <DropdownToggle size="sm" caret color="primary">
              <img className="actions-btn" src="/automation-icon-disabled.png"/>
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem onClick={onNewMix}size="sm">New Mix</DropdownItem>
            </DropdownMenu>
          </ButtonDropdown>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SidePanelToolbar);
